export default __webpack_public_path__ + "locales/az/DeleteProfileEverDialog.json?hash=6832b743cc81a88a9dd90ce42b30629d";